/**
 * Normalize gender strings from CSV/spreadsheet imports to canonical student gender values.
 * Returns null when the cell is empty or not recognized (callers should treat as invalid when non-empty raw fails).
 */
export function normalizeImportedStudentGender(raw: string | undefined | null): 'male' | 'female' | 'other' | null {
  const g = String(raw ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (!g) return null;

  if (g === 'male' || g === 'm') return 'male';
  if (g === 'female' || g === 'f') return 'female';
  if (g === 'other' || g === 'o') return 'other';

  const otherAliases = new Set([
    'non-binary',
    'nonbinary',
    'non binary',
    'gender non-conforming',
    'gender non conforming',
    'genderqueer',
    'gender queer',
    'nb',
    'x',
    'prefer not to say',
    'prefer not to disclose',
    'decline to state',
    'unspecified',
    'unknown',
    'n/a',
    'na',
    'diverse',
    'gender diverse',
    'third gender',
    '3rd gender',
  ]);

  if (otherAliases.has(g)) return 'other';

  return null;
}
